import React from 'react';
import styled from 'styled-components';
import alertCircle from '../../../../assets/icons/events/alertCircle.svg';
import alertCircleWhite from '../../../../assets/icons/events/alertCircleWhite.svg';
import alertCircleCancel from '../../../../assets/icons/reinforcement/alert-circle-cancel.svg';

interface RescheduledProps {
  isRescheduled: boolean;
  colorProp?: string;
  isCanceled?: boolean;
}

const ContainerRescheduled = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 5px;
`;

const AlertCircle = styled.img`
  margin-right: 6px;
`;

const TagRescheduledStyled = styled.span.attrs((props: any) => ({
  color: props.color
}))`
  // padding: 2px 0px;
  font-style: normal;
  font-weight: 900 !important;
  font-size: 14px;
  line-height: 20px;
  color: ${(props) => props.color};
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`;

const TagRescheduled = (parametros: RescheduledProps) => {
  const { isRescheduled, colorProp, isCanceled } = parametros;
  return (
    <>
      {isRescheduled && isCanceled && (
        <ContainerRescheduled>
          <AlertCircle src={alertCircleCancel} alt="reprogramado cancel" />
          <TagRescheduledStyled color={colorProp}>
            Reprogramado
          </TagRescheduledStyled>
        </ContainerRescheduled>
      )}
      {isRescheduled && !isCanceled && (
        <ContainerRescheduled>
          <AlertCircle
            style={{ marginRight: '0px' }}
            src={colorProp === '#0071BF' ? alertCircle : alertCircleWhite}
            alt="reprogramado"
          />
          <TagRescheduledStyled color={colorProp}>
            Reprogramado
          </TagRescheduledStyled>
        </ContainerRescheduled>
      )}
    </>
  );
};

TagRescheduled.defaultProps = {
  colorProp: '#0071BF',
  isCanceled: false
};

export default TagRescheduled;
